import { signOut } from "@kaplan-labs/up-auth-api-client";
import { SignOutIcon } from "@phosphor-icons/react/dist/ssr/SignOut";

import { StudentsPage } from "@up/profile";
import { Animation, Toast, ToastTitle } from "@up/ui";

export function Guardian() {
  return (
    <>
      <Animation type="splash-in">
        <Toast size="large" variant="info">
          <ToastTitle autoFocus={true} data-testid="application-thanks-heading">
            You are signed in as a Guardian
          </ToastTitle>
          You may enroll an admitted student below. Is there another student
          that needs to enroll? You can sign out below and they can start a new
          application with their email.
        </Toast>
      </Animation>
      <br />
      <StudentsPage minimal />
      <br />
      <div className="p-5 md:bg-[#F6F6F6]">
        Is there another student that needs to enroll? You can sign out below
        and they can start a new application with their email.
        <button
          className="flex px-1 py-1 text-lg flex-col items-center text-black underline opacity-60 md:flex-row md:gap-2 md:py-2"
          onClick={signOut}
        >
          <SignOutIcon size={24} />
          Sign Out
        </button>
      </div>
    </>
  );
}
